var exports = {
  "YB": "ThreePanesLayout__DTljtA",
  "y9": "FooterRedesignOffset__jn-ucY",
  "o3": "hasStickySidebar__RVMQ6C",
  "b8": "ThreePanesLayoutLeftPane__MrZxiC",
  "B7": "ThreePanesLayoutNested__RTgSv3",
  "jU": "ThreePanesLayoutMiddlePane__-8rfR_",
  "N8": "ThreePanesLayoutMiddleOnlyPane__GHEJtC",
};

module.exports = exports;
